import { Notification } from 'element-ui';

export async function copyThis(value, formatted = true) {
    try {   
        if (!value) {
            Notification.info({
                title: 'Informação',
                message: 'Não há nenhum valor para copiar!',
            });
        };

        let text = String(value);

        if (!formatted) {
            text = text.replace(/[^\p{L}\p{N}]/gu, '');
        }

        await navigator.clipboard.writeText(text);

        Notification.success({
            title: 'Sucesso',
            message: 'Copiado para a área de transferência',
        });
    } catch(err) {
        Notification.error({
            title: 'Erro',
            message: 'Não foi possível copiar para a área de transferência. Algo inesperado ocorreu!',
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/util/copyThis.js